import { render } from "./BasicCard.vue?vue&type=template&id=8e13731e&scoped=true"
import script from "./BasicCard.vue?vue&type=script&lang=js"
export * from "./BasicCard.vue?vue&type=script&lang=js"

import "./BasicCard.css?vue&type=style&index=0&id=8e13731e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Kwassim\\Documents\\Projects\\AcquaPalace\\vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e13731e"]])

export default __exports__